export default "__VITE_ASSET__2a176025__"